// Cuenta recordada del login ("Hola de nuevo"): al entrar se guardan correo,
// nombre y foto, y en la siguiente visita el login ya no pide el correo, solo
// la contraseña. Portado de app.js (cuentaRecordada / guardarCuentaRecordada,
// ~187-215).
//
// La clave y la forma del JSON son las MISMAS que la app actual a propósito:
// beta y producción viven en el mismo dominio y comparten localStorage, así
// que si aquí se escribiera otro formato, el login del Radar actual dejaría de
// reconocer la cuenta (y al revés).
import { supa } from "./supabase";
import type { CuentaRecordada } from "./tipos";

export const CUENTA_KEY = "kex_cuenta_recordada";

// lo que hay en localStorage puede venir de una versión vieja, estar a medias o
// ser basura: sin email no hay nada que recordar
function normalizar(valor: unknown): CuentaRecordada | null {
  if (typeof valor !== "object" || valor === null) return null;
  const o = valor as Record<string, unknown>;
  if (typeof o.email !== "string" || !o.email) return null;
  return {
    email: o.email,
    nombre: typeof o.nombre === "string" ? o.nombre : "",
    avatar: typeof o.avatar === "string" && o.avatar ? o.avatar : null,
  };
}

export function cuentaRecordada(): CuentaRecordada | null {
  try {
    const crudo = localStorage.getItem(CUENTA_KEY);
    return crudo ? normalizar(JSON.parse(crudo) as unknown) : null;
  } catch {
    // modo privado, cuota llena o JSON roto: se entra con el login completo
    return null;
  }
}

interface DatosCuenta {
  nombre?: string | null;
  apellido?: string | null;
  avatar_url?: string | null;
}

/** Guarda (o actualiza) la cuenta del login. `email` se puede pasar cuando ya
 *  se tiene a la mano; si no, se pregunta a Supabase. Nunca lanza: es una
 *  comodidad del login, no parte del guardado de nada. */
export async function guardarCuentaRecordada(
  perfil: DatosCuenta,
  email?: string | null,
): Promise<void> {
  try {
    let correo = email ?? null;
    if (!correo) {
      const {
        data: { user },
      } = await supa.auth.getUser();
      correo = user?.email ?? null;
    }
    if (!correo) return;
    // un "nombre" que en realidad es el correo no se muestra como nombre
    const nombre = [perfil.nombre, perfil.apellido]
      .filter((x) => x && !x.includes("@"))
      .join(" ");
    localStorage.setItem(
      CUENTA_KEY,
      JSON.stringify({
        email: correo,
        nombre,
        avatar: perfil.avatar_url ?? null,
      }),
    );
  } catch {
    // ver arriba: que falle recordar la cuenta no debe romper nada
  }
}

export function olvidarCuentaRecordada(): void {
  try {
    localStorage.removeItem(CUENTA_KEY);
  } catch {
    // ver arriba
  }
}
